// extracted by mini-css-extract-plugin
export default {"headRow":"oDJfI16BchIPFwRo7jKW"};